import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=1af16795&scoped=true&"
import script from "./InputBox.vue?vue&type=script&lang=js&"
export * from "./InputBox.vue?vue&type=script&lang=js&"
import style0 from "./InputBox.vue?vue&type=style&index=0&id=1af16795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af16795",
  null
  
)

export default component.exports